import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {UtilsService} from '../../core/services/utils/utils.service';

@Component({
    selector: 'app-nft-collection',
    templateUrl: './nft-collection.component.html',
    styleUrls: ['./nft-collection.component.css'],
    standalone: false
})
export class NftCollectionComponent implements OnInit {

  sort: any;
  collections = [];
  loading = true;
  loaders = Array(10).fill(0);

  constructor(private api: ApiService,
              private utils: UtilsService,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.getNftCollections();
  }

  changed(): void {

  }

  toggleCollection(id): void {
    this.api.nftCollectionStatusUpdate(id).subscribe(res => {
      this.toastr.success('Status updated successfully!');
      this.getNftCollections();
    });
  }

  getNftCollections(): void{
    this.api.getNftCollections().subscribe(res => {
      this.collections = res.response;
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }

  handleCopyToClipboard(str: any = ''): void {
    this.utils.copyToClipboard(str);
    this.utils.toastSuccess('ID copied to your clipboard successfully');
  }
}
